import SurveyAttr from "models/SurveyAttr";

export const SET = "answerAttribute/SET";
export const SET_NEXT_SURVEY_ATTR = "answerAttribute/SET_NEXT_SURVEY_ATTR";
export const SET_PREV_SURVEY_ATTR = "answerAttribute/SET_PREV_SURVEY_ATTR";
export const SET_CURRENT_SURVEY_ORDER = "answerAttribute/SET_CURRENT_SURVEY_ORDER";
export const SET_CURRENT_SURVEY_ATTRIBUTE = "answerAttribute/SET_CURRENT_SURVEY_ATTRIBUTE";

export const set = surveyAttrs => ({
  type: SET,
  surveyAttrs: surveyAttrs.map(sa => new SurveyAttr(sa))
});

export const setNextSurveyAttr = () => ({
  type: SET_NEXT_SURVEY_ATTR
});

export const setPrevSurveyAttr = () => ({
  type: SET_PREV_SURVEY_ATTR
});

export const setCurrentSurveyAttrOrder = order => ({
  type: SET_CURRENT_SURVEY_ORDER,
  order
});

export const setCurrentSurveyAttr = order => ({
  type: SET_CURRENT_SURVEY_ATTRIBUTE,
  order
});

const initialState = {
  currentSurveyAttr: new SurveyAttr(),
  surveyAttrs: []
};

const answerAttribute = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET: {
      const { surveyAttrs } = action;
      const currentSurveyAttr = surveyAttrs[0];

      return {
        ...state,
        surveyAttrs,
        currentSurveyAttr
      };
    }

    case SET_NEXT_SURVEY_ATTR: {
      const nextSurveyAttr = state.surveyAttrs[state.currentSurveyAttr.order];

      return { ...state, currentSurveyAttr: nextSurveyAttr };
    }

    case SET_PREV_SURVEY_ATTR: {
      const prevSurverAttr =
        state.surveyAttrs[state.currentSurveyAttr.order - 2];

      return { ...state, currentSurveyAttr: prevSurverAttr };
    }

    case SET_CURRENT_SURVEY_ORDER: {
      return {
        ...state,
        currentSurveyAttr: new SurveyAttr({
          ...state.currentSurveyAttr,
          order: action.order
        })
      };
    }
    
    case SET_CURRENT_SURVEY_ATTRIBUTE: {
      const surveyAttr = state.surveyAttrs[action.order - 1];

      return {
        ...state,
        currentSurveyAttr: surveyAttr || new SurveyAttr()
      };
    }

    default: {
      return state;
    }
  }
};

export default answerAttribute;



// WEBPACK FOOTER //
// ./src/redux/modules/answer/answerAttribute.js